/**
 * Acción "Crear solicitud" de un punto de suministro (ADS-0125).
 *
 * Desde el historial de luz o gas, el detalle de un CUPS y la ficha del
 * inmueble se abre el formulario de solicitud con el suministro de origen. Se
 * reutiliza el catálogo de tipologías con dos salvedades: no se ofrece "Alta
 * de suministro" porque el CUPS ya existe (ADS-0107), y el formulario recibe
 * `supply_id` y `supply_type` para vincular la solicitud, precargar sus datos y
 * fijar la energía —así un gas no puede pedir potencias—.
 */
// Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
// export const SUPPLY_REQUEST_TYPES = ['change_ownership', 'change_supplier', 'account_change', 'invoice', 'other_type']
export const SUPPLY_REQUEST_TYPES = ['change_ownership', 'account_change', 'invoice', 'other_type']

export const SUPPLY_TYPES = ['light', 'gas']

const normalizeType = (type) => {
  const value = String(type || '').toLowerCase()
  if (value === 'luz') return 'light'
  return SUPPLY_TYPES.includes(value) ? value : ''
}

/** Query con la que el formulario reconoce el suministro de origen. */
export const supplyRequestQuery = (supply) => {
  const type = normalizeType(supply?.type)
  if (!supply?.id || !type) return {}
  return { supply_id: String(supply.id), supply_type: type }
}

/**
 * Opciones del menú. Sin `supply` la query se resuelve por fila (tablas); con
 * él queda fijada (detalle de un suministro).
 */
export const supplyRequestOptions = (t, supply = null) => SUPPLY_REQUEST_TYPES.map((type) => ({
  key: `/forms/${type}`,
  label: t(`common.requestTypes.${type}`),
  query: supply ? supplyRequestQuery(supply) : supplyRequestQuery,
}))

/** Acciones de "Otro" que no aplican a un suministro de gas. */
export const OTHER_ACTIONS_LIGHT_ONLY = ['modificar_potencia']

export const allowsOtherAction = (action, supplyType) =>
  normalizeType(supplyType) !== 'gas' || !OTHER_ACTIONS_LIGHT_ONLY.includes(action)
